const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const TOKEN_KEY = 'admin_token';
const PROFILE_KEY = 'admin_profile';

// Dummy / built-in admin credentials
const DUMMY_ADMIN_EMAIL = 'paola@todoenbalance.com';
const DUMMY_ADMIN_PASS = '234carlitos24@@#$';

// Local storage keys for fallback state when backend is offline/unreachable
const LS_PRODUCTS_KEY = 'admin_local_products';
const LS_BOOKINGS_KEY = 'admin_local_bookings';
const LS_AVAILABILITY_KEY = 'admin_local_availability';
const LS_CONTACTS_KEY = 'admin_local_contacts';
const LS_PATIENTS_KEY = 'admin_local_patients';
const LS_NOTES_KEY = 'admin_local_consultation_notes';
const LS_MEASUREMENTS_KEY = 'admin_local_measurements';
const LS_MEAL_PLANS_KEY = 'admin_local_meal_plans';
const LS_FOODS_KEY = 'admin_local_foods';

const DEFAULT_LOCAL_PRODUCTS = [
  {
    id: 'local-consultation-30',
    slug: 'consultation_30',
    kind: 'consultation',
    title_i18n: {
      en: '30-Minute Initial Consultation',
      es: 'Consulta Inicial de 30 Minutos',
      it: 'Consulenza Iniziale di 30 Minuti',
    },
    description_i18n: {
      en: 'Personalized nutrition assessment, goal setting, and actionable next steps.',
      es: 'Evaluación nutricional personalizada, definición de objetivos y próximos pasos.',
      it: 'Valutazione nutrizionale personalizzata, definizione degli obiettivi e prossimi passi.',
    },
    features_i18n: {
      en: ['1-on-1 video call', 'Dietary habits review', 'Action plan summary'],
      es: ['Videollamada 1 a 1', 'Revisión de hábitos', 'Resumen del plan de acción'],
      it: ['Videochiamata 1-a-1', 'Revisione abitudini', 'Riepilogo piano d’azione'],
    },
    price_cents: 5000,
    currency: 'eur',
    duration_minutes: 30,
    badge: null,
    is_active: true,
    sort_order: 1,
    has_pdf: false,
  },
  {
    id: 'local-consultation-60',
    slug: 'consultation_60',
    kind: 'consultation',
    title_i18n: {
      en: '60-Minute Deep-Dive Consultation',
      es: 'Consulta Completa de 60 Minutos',
      it: 'Consulenza Completa di 60 Minuti',
    },
    description_i18n: {
      en: 'Comprehensive nutrition & lifestyle strategy with personalized meal planning.',
      es: 'Estrategia integral de nutrición y estilo de vida con planificación de comidas.',
      it: 'Strategia completa di nutrizione e stile di vita con pianificazione dei pasti.',
    },
    features_i18n: {
      en: ['60-min video session', 'Custom meal plan', 'Follow-up support'],
      es: ['Sesión de video de 60 min', 'Plan de comidas personalizado', 'Soporte de seguimiento'],
      it: ['Sessione video di 60 min', 'Piano alimentare personalizzato', 'Supporto di follow-up'],
    },
    price_cents: 8500,
    currency: 'eur',
    duration_minutes: 60,
    badge: 'Most Popular',
    is_active: true,
    sort_order: 2,
    has_pdf: false,
  },
  {
    id: 'local-diet-mediterranean',
    slug: 'diet_mediterranean',
    kind: 'ebook',
    title_i18n: {
      en: '1-Week Mediterranean Diet Plan',
      es: 'Plan de Dieta Mediterránea de 1 Semana',
      it: 'Piano Dieta Mediterranea di 1 Settimana',
    },
    description_i18n: {
      en: 'Balanced, heart-healthy Mediterranean meals with complete shopping list & recipes.',
      es: 'Comidas mediterráneas equilibradas con lista de compras completa y recetas.',
      it: 'Pasti mediterranei equilibrati con lista della spesa completa e ricette.',
    },
    features_i18n: {
      en: ['7 daily meal plans with recipes', 'Complete grocery list', 'Meal prep guide'],
      es: ['7 planes diarios con recetas', 'Lista de compras completa', 'Guía de meal prep'],
      it: ['7 piani giornalieri con ricette', 'Lista della spesa completa', 'Guida meal prep'],
    },
    price_cents: 999,
    currency: 'eur',
    duration_minutes: null,
    badge: 'Best Seller',
    is_active: true,
    sort_order: 10,
    has_pdf: false,
  },
  {
    id: 'local-diet-lowcarb',
    slug: 'diet_lowcarb',
    kind: 'ebook',
    title_i18n: {
      en: '1-Week Low-Carb Reset Plan',
      es: 'Plan Low-Carb de 1 Semana',
      it: 'Piano Low-Carb di 1 Settimana',
    },
    description_i18n: {
      en: 'High-protein, low-glycemic recipes designed for steady energy and satiety.',
      es: 'Recetas ricas en proteínas y de bajo índice glucémico para energía constante.',
      it: 'Ricette ricche di proteine e a basso indice glicemico per energia costante.',
    },
    features_i18n: {
      en: ['7 daily meal plans with macros', 'Complete grocery list', 'Snack swap guide'],
      es: ['7 planes diarios con macros', 'Lista de compras completa', 'Guía de snacks'],
      it: ['7 piani giornalieri con macro', 'Lista della spesa completa', 'Guida agli snack'],
    },
    price_cents: 999,
    currency: 'eur',
    duration_minutes: null,
    badge: null,
    is_active: true,
    sort_order: 20,
    has_pdf: false,
  },
  {
    id: 'local-diet-plantbased',
    slug: 'diet_plantbased',
    kind: 'ebook',
    title_i18n: {
      en: '1-Week Plant-Based Plan',
      es: 'Plan Plant-Based de 1 Semana',
      it: 'Piano Plant-Based di 1 Settimana',
    },
    description_i18n: {
      en: 'Vibrant, nutrient-dense plant-based recipes with complete protein pairings.',
      es: 'Recetas vegetales ricas en nutrientes con combinaciones completas de proteínas.',
      it: 'Ricette vegetali ricche di nutrienti con abbinamenti proteici completi.',
    },
    features_i18n: {
      en: ['7 daily plant-based menus', 'Complete grocery list', 'Protein pairing guide'],
      es: ['7 menús diarios plant-based', 'Lista de compras completa', 'Guía de proteínas'],
      it: ['7 menu giornalieri plant-based', 'Lista della spesa completa', 'Guida alle proteine'],
    },
    price_cents: 999,
    currency: 'eur',
    duration_minutes: null,
    badge: null,
    is_active: true,
    sort_order: 30,
    has_pdf: false,
  },
];

const DEFAULT_LOCAL_AVAILABILITY = {
  settings: {
    business_timezone: 'Europe/Madrid',
    horizon_days: 28,
    min_notice_hours: 12,
  },
  rules: [
    { id: 'rule-0', weekday: 0, start_time: '09:00', end_time: '17:00', slot_interval_minutes: 60, is_active: true },
    { id: 'rule-1', weekday: 1, start_time: '09:00', end_time: '17:00', slot_interval_minutes: 60, is_active: true },
    { id: 'rule-2', weekday: 2, start_time: '09:00', end_time: '17:00', slot_interval_minutes: 60, is_active: true },
    { id: 'rule-3', weekday: 3, start_time: '09:00', end_time: '17:00', slot_interval_minutes: 60, is_active: true },
    { id: 'rule-4', weekday: 4, start_time: '09:00', end_time: '15:00', slot_interval_minutes: 60, is_active: true },
  ],
  exceptions: [],
};

const DEFAULT_LOCAL_PATIENTS = [
  {
    id: 'patient-demo-1',
    full_name: 'Elena Rossi',
    email: 'elena.rossi@example.it',
    phone: '+39 340 555 0192',
    birth_date: '1991-05-14',
    sex: 'female',
    occupation: 'Architect',
    preferred_language: 'it',
    status: 'active',
    tags: ['Weight Management', 'Mediterranean', 'Insulin Resistance'],
    clinical_profile: {
      primary_goal: 'Lose 6 kg of fat mass, stabilize afternoon energy, and improve post-meal digestion.',
      medical_conditions: 'Mild insulin resistance (HOMA-IR 2.7), seasonal allergies.',
      medications_supplements: 'Vitamin D3 2000 IU, Magnesium bisglycinate 300mg at night.',
      allergies_intolerances: 'Lactose sensitivity (tolerates aged cheese & Greek yogurt).',
      family_history: 'Type 2 diabetes (maternal grandfather).',
      digestive_health: 'Occasional evening bloating when eating refined wheat.',
      sleep_hours: 7,
      stress_level: 'moderate',
      activity_level: 'moderately_active',
      water_intake_liters: 2.0,
      food_likes: 'Fish, quinoa, berries, extra virgin olive oil, dark chocolate.',
      food_dislikes: 'Brussels sprouts, pork.',
      dietary_recall_24h: 'Breakfast: espresso + croissant. Lunch: pasta pomodoro. Snack: crackers. Dinner: chicken salad.',
      clinical_summary: 'Responds very well to high-protein savory breakfasts and structured afternoon snacks.',
    },
    target_kcal: 1700,
    target_macros: {
      protein_g: 115,
      carbs_g: 165,
      fat_g: 62,
      fiber_g: 32,
      water_liters: 2.2,
    },
    created_at: '2026-09-10T10:00:00Z',
    updated_at: '2026-10-28T15:30:00Z',
  },
  {
    id: 'patient-demo-2',
    full_name: 'Sofía Mendoza',
    email: 'sofia.mendoza@example.mx',
    phone: '+52 81 1234 5678',
    birth_date: '1994-11-22',
    sex: 'female',
    occupation: 'Marketing Director',
    preferred_language: 'es',
    status: 'active',
    tags: ['Sports Nutrition', 'Body Recomposition', 'Hormonal Balance'],
    clinical_profile: {
      primary_goal: 'Increase lean muscle mass (+2 kg) while improving hormonal regularity and running performance.',
      medical_conditions: 'None reported.',
      medications_supplements: 'Creatine monohydrate 3g/day, Omega-3.',
      allergies_intolerances: 'None.',
      family_history: 'Hypothyroidism (mother).',
      digestive_health: 'Optimal.',
      sleep_hours: 7.5,
      stress_level: 'low',
      activity_level: 'very_active',
      water_intake_liters: 2.5,
      food_likes: 'Avocado, eggs, corn tortillas, black beans, salmon, mango.',
      food_dislikes: 'Cottage cheese.',
      dietary_recall_24h: 'Balanced 4 meals/day, needs more carbohydrates around morning strength training.',
      clinical_summary: 'Increasing pre/post-workout carbohydrates improved recovery immediately.',
    },
    target_kcal: 2050,
    target_macros: {
      protein_g: 135,
      carbs_g: 225,
      fat_g: 68,
      fiber_g: 34,
      water_liters: 2.5,
    },
    created_at: '2026-09-25T11:00:00Z',
    updated_at: '2026-10-30T17:00:00Z',
  },
];

const DEFAULT_LOCAL_NOTES = [
  {
    id: 'note-demo-1',
    patient_id: 'patient-demo-1',
    session_date: '2026-10-28',
    session_type: 'Follow-up',
    adherence_score: 5,
    subjective: 'Elena reports much steadier energy at 16:00 since switching to savory egg + sourdough breakfast. Zero afternoon sugar cravings this week.',
    objective: 'Weight: 65.4 kg (-1.8 kg since initial visit). Waist circumference reduced by 2.5 cm (from 76.0 cm to 73.5 cm).',
    assessment: 'Excellent adherence (90%) to the anti-inflammatory Mediterranean plan. Glycemic variability improved.',
    plan: '1. Keep 1700 kcal target.\n2. Introduce 2 legume-based lunches per week (lentils/chickpeas).\n3. Maintain 8,500 daily steps + 2x Pilates sessions.',
    private_notes: 'Schedule follow-up lab check (fasting insulin & HbA1c) in 6 weeks.',
    created_at: '2026-10-28T15:30:00Z',
  },
  {
    id: 'note-demo-2',
    patient_id: 'patient-demo-1',
    session_date: '2026-09-15',
    session_type: 'Initial',
    adherence_score: 4,
    subjective: 'Initial 60-minute assessment. Main complaint: afternoon fatigue, difficulty losing abdominal fat despite eating small portions.',
    objective: 'Initial Weight: 67.2 kg, Height: 165 cm, BMI: 24.7, Body Fat: 29.8%, Waist: 76.0 cm.',
    assessment: 'Low protein intake at breakfast (<10g) and long gaps between lunch and dinner leading to evening grazing.',
    plan: 'Start 1700 kcal Mediterranean plan with 30g protein at main meals and structured 17:00 snack.',
    private_notes: '',
    created_at: '2026-09-15T10:00:00Z',
  },
];

const DEFAULT_LOCAL_MEASUREMENTS = [
  {
    id: 'meas-demo-1',
    patient_id: 'patient-demo-1',
    measured_at: '2026-09-15',
    weight_kg: 67.2,
    height_cm: 165,
    bmi: 24.7,
    body_fat_pct: 29.8,
    muscle_mass_kg: 44.5,
    visceral_fat: 6,
    waist_cm: 76.0,
    hip_cm: 99.0,
    arm_cm: 28.5,
    thigh_cm: 56.0,
    lab_markers: {
      glucose_mg_dl: 96,
      hba1c_pct: 5.5,
      cholesterol_total: 198,
      vitamin_d_ng_ml: 24,
      ferritin_ng_ml: 45,
      tsh_miu_l: 2.1,
    },
    notes: 'Baseline initial assessment.',
  },
  {
    id: 'meas-demo-2',
    patient_id: 'patient-demo-1',
    measured_at: '2026-10-05',
    weight_kg: 66.3,
    height_cm: 165,
    bmi: 24.4,
    body_fat_pct: 28.9,
    muscle_mass_kg: 44.7,
    visceral_fat: 5.5,
    waist_cm: 74.8,
    hip_cm: 98.2,
    arm_cm: 28.3,
    thigh_cm: 55.4,
    lab_markers: {},
    notes: 'Week 3 check-in — lean mass preserved.',
  },
  {
    id: 'meas-demo-3',
    patient_id: 'patient-demo-1',
    measured_at: '2026-10-28',
    weight_kg: 65.4,
    height_cm: 165,
    bmi: 24.0,
    body_fat_pct: 27.8,
    muscle_mass_kg: 45.0,
    visceral_fat: 5.0,
    waist_cm: 73.5,
    hip_cm: 97.4,
    arm_cm: 28.2,
    thigh_cm: 54.8,
    lab_markers: {
      glucose_mg_dl: 89,
      hba1c_pct: 5.2,
      vitamin_d_ng_ml: 36,
    },
    notes: 'Week 6 check-in — -1.8 kg total, -2% body fat.',
  },
];

const DEFAULT_LOCAL_FOODS = [
  { id: 'food-1', name_i18n: { en: 'Chicken Breast (Grilled)', es: 'Pechuga de Pollo (Plancha)', it: 'Petto di Pollo (Alla Piastra)' }, category: 'Proteins', kcal_per_100g: 165, protein_per_100g: 31.0, carbs_per_100g: 0.0, fat_per_100g: 3.6, fiber_per_100g: 0.0, default_portion_name: '1 fillet (150g)', default_portion_grams: 150, is_recipe: false },
  { id: 'food-2', name_i18n: { en: 'Wild Atlantic Salmon', es: 'Salmón Fresco', it: 'Salmone Fresco' }, category: 'Proteins', kcal_per_100g: 208, protein_per_100g: 20.4, carbs_per_100g: 0.0, fat_per_100g: 13.4, fiber_per_100g: 0.0, default_portion_name: '1 fillet (140g)', default_portion_grams: 140, is_recipe: false },
  { id: 'food-3', name_i18n: { en: 'White Fish / Cod / Hake', es: 'Merluza / Pescado Blanco', it: 'Merluzzo / Pesce Bianco' }, category: 'Proteins', kcal_per_100g: 82, protein_per_100g: 17.8, carbs_per_100g: 0.0, fat_per_100g: 0.7, fiber_per_100g: 0.0, default_portion_name: '1 fillet (180g)', default_portion_grams: 180, is_recipe: false },
  { id: 'food-4', name_i18n: { en: 'Whole Eggs (Free-Range)', es: 'Huevos Enteros Camperos', it: 'Uova Intere' }, category: 'Proteins', kcal_per_100g: 143, protein_per_100g: 12.6, carbs_per_100g: 0.7, fat_per_100g: 9.5, fiber_per_100g: 0.0, default_portion_name: '2 large eggs (110g)', default_portion_grams: 110, is_recipe: false },
  { id: 'food-5', name_i18n: { en: 'Turkey Breast', es: 'Pechuga de Pavo', it: 'Fesa di Tacchino' }, category: 'Proteins', kcal_per_100g: 135, protein_per_100g: 30.0, carbs_per_100g: 0.0, fat_per_100g: 1.0, fiber_per_100g: 0.0, default_portion_name: '150g', default_portion_grams: 150, is_recipe: false },
  { id: 'food-6', name_i18n: { en: 'Firm Organic Tofu', es: 'Tofu Firme Orgánico', it: 'Tofu Compatto Bio' }, category: 'Proteins', kcal_per_100g: 144, protein_per_100g: 15.7, carbs_per_100g: 2.8, fat_per_100g: 8.7, fiber_per_100g: 2.3, default_portion_name: '150g', default_portion_grams: 150, is_recipe: false },
  { id: 'food-7', name_i18n: { en: 'Rolled Oats', es: 'Copos de Avena Integral', it: "Fiocchi d'Avena Integrali" }, category: 'Grains', kcal_per_100g: 389, protein_per_100g: 16.9, carbs_per_100g: 66.3, fat_per_100g: 6.9, fiber_per_100g: 10.6, default_portion_name: '1/2 cup dry (50g)', default_portion_grams: 50, is_recipe: false },
  { id: 'food-8', name_i18n: { en: 'Cooked Quinoa', es: 'Quinoa Cocida', it: 'Quinoa Cotta' }, category: 'Grains', kcal_per_100g: 120, protein_per_100g: 4.4, carbs_per_100g: 21.3, fat_per_100g: 1.9, fiber_per_100g: 2.8, default_portion_name: '1 cup cooked (150g)', default_portion_grams: 150, is_recipe: false },
  { id: 'food-9', name_i18n: { en: 'Cooked Brown Rice', es: 'Arroz Integral Cocido', it: 'Riso Integrale Cotto' }, category: 'Grains', kcal_per_100g: 123, protein_per_100g: 2.7, carbs_per_100g: 25.6, fat_per_100g: 1.0, fiber_per_100g: 1.8, default_portion_name: '1 cup cooked (150g)', default_portion_grams: 150, is_recipe: false },
  { id: 'food-10', name_i18n: { en: 'Whole-Grain Sourdough Bread', es: 'Pan Integral de Masa Madre', it: 'Pane Integrale a Lievitazione Naturale' }, category: 'Grains', kcal_per_100g: 247, protein_per_100g: 10.5, carbs_per_100g: 43.0, fat_per_100g: 3.4, fiber_per_100g: 6.8, default_portion_name: '2 slices (70g)', default_portion_grams: 70, is_recipe: false },
  { id: 'food-11', name_i18n: { en: 'Roasted Sweet Potato', es: 'Boniato / Camote Asado', it: 'Patata Dolce al Forno' }, category: 'Grains', kcal_per_100g: 90, protein_per_100g: 2.0, carbs_per_100g: 20.7, fat_per_100g: 0.2, fiber_per_100g: 3.3, default_portion_name: '1 medium (160g)', default_portion_grams: 160, is_recipe: false },
  { id: 'food-12', name_i18n: { en: 'Corn Tortillas (Nixtamalized)', es: 'Tortillas de Maíz Nixtamalizado', it: 'Tortillas di Mais' }, category: 'Grains', kcal_per_100g: 218, protein_per_100g: 5.7, carbs_per_100g: 44.6, fat_per_100g: 2.9, fiber_per_100g: 6.3, default_portion_name: '2 tortillas (60g)', default_portion_grams: 60, is_recipe: false },
  { id: 'food-13', name_i18n: { en: 'Cooked Lentils', es: 'Lentejas Cocidas', it: 'Lenticchie Cotte' }, category: 'Legumes', kcal_per_100g: 116, protein_per_100g: 9.0, carbs_per_100g: 20.1, fat_per_100g: 0.4, fiber_per_100g: 7.9, default_portion_name: '1 cup cooked (180g)', default_portion_grams: 180, is_recipe: false },
  { id: 'food-14', name_i18n: { en: 'Cooked Chickpeas / Garbanzos', es: 'Garbanzos Cocidos', it: 'Ceci Cotti' }, category: 'Legumes', kcal_per_100g: 164, protein_per_100g: 8.9, carbs_per_100g: 27.4, fat_per_100g: 2.6, fiber_per_100g: 7.6, default_portion_name: '1 cup cooked (160g)', default_portion_grams: 160, is_recipe: false },
  { id: 'food-15', name_i18n: { en: 'Greek Yogurt (Plain, 2% Fat)', es: 'Yogur Griego Natural Ligero', it: 'Yogurt Greco Bianco 2%' }, category: 'Dairy', kcal_per_100g: 73, protein_per_100g: 9.9, carbs_per_100g: 3.8, fat_per_100g: 1.9, fiber_per_100g: 0.0, default_portion_name: '1 bowl (170g)', default_portion_grams: 170, is_recipe: false },
  { id: 'food-16', name_i18n: { en: 'Fresh Ricotta / Cottage Cheese', es: 'Requesón / Queso Cottage', it: 'Ricotta Fresca / Fiocchi di Latte' }, category: 'Dairy', kcal_per_100g: 98, protein_per_100g: 11.1, carbs_per_100g: 3.4, fat_per_100g: 4.3, fiber_per_100g: 0.0, default_portion_name: '100g', default_portion_grams: 100, is_recipe: false },
  { id: 'food-17', name_i18n: { en: 'Extra Virgin Olive Oil (EVOO)', es: 'Aceite de Oliva Virgen Extra (AOVE)', it: "Olio Extravergine d'Oliva (EVO)" }, category: 'Fats', kcal_per_100g: 884, protein_per_100g: 0.0, carbs_per_100g: 0.0, fat_per_100g: 100.0, fiber_per_100g: 0.0, default_portion_name: '1 tbsp (10g)', default_portion_grams: 10, is_recipe: false },
  { id: 'food-18', name_i18n: { en: 'Fresh Hass Avocado', es: 'Aguacate Hass Fresco', it: 'Avocado Maturo' }, category: 'Fats', kcal_per_100g: 160, protein_per_100g: 2.0, carbs_per_100g: 8.5, fat_per_100g: 14.7, fiber_per_100g: 6.7, default_portion_name: '1/2 avocado (70g)', default_portion_grams: 70, is_recipe: false },
  { id: 'food-19', name_i18n: { en: 'Raw Almonds & Walnuts', es: 'Nueces y Almendras Naturales', it: 'Noci e Mandorle al Naturale' }, category: 'Fats', kcal_per_100g: 607, protein_per_100g: 18.2, carbs_per_100g: 16.7, fat_per_100g: 54.4, fiber_per_100g: 9.8, default_portion_name: '1 handful (25g)', default_portion_grams: 25, is_recipe: false },
  { id: 'food-20', name_i18n: { en: 'Mixed Leafy Greens & Spinach', es: 'Espinacas y Brotes Verdes', it: 'Spinaci e Misticanza' }, category: 'Produce', kcal_per_100g: 23, protein_per_100g: 2.9, carbs_per_100g: 3.6, fat_per_100g: 0.4, fiber_per_100g: 2.2, default_portion_name: '2 cups (100g)', default_portion_grams: 100, is_recipe: false },
  { id: 'food-21', name_i18n: { en: 'Steamed Broccoli & Zucchini', es: 'Brócoli y Calabacín al Vapor', it: 'Broccoli e Zucchine al Vapore' }, category: 'Produce', kcal_per_100g: 28, protein_per_100g: 2.4, carbs_per_100g: 5.2, fat_per_100g: 0.3, fiber_per_100g: 2.4, default_portion_name: '1 generous plate (200g)', default_portion_grams: 200, is_recipe: false },
  { id: 'food-22', name_i18n: { en: 'Fresh Mixed Berries', es: 'Frutos Rojos (Arándanos y Fresas)', it: 'Frutti di Bosco Freschi' }, category: 'Fruits', kcal_per_100g: 45, protein_per_100g: 0.8, carbs_per_100g: 10.5, fat_per_100g: 0.3, fiber_per_100g: 3.2, default_portion_name: '1 cup (120g)', default_portion_grams: 120, is_recipe: false },
  { id: 'food-23', name_i18n: { en: 'Apple / Pear', es: 'Manzana / Pera con Piel', it: 'Mela / Pera con Buccia' }, category: 'Fruits', kcal_per_100g: 52, protein_per_100g: 0.3, carbs_per_100g: 13.8, fat_per_100g: 0.2, fiber_per_100g: 2.4, default_portion_name: '1 medium fruit (150g)', default_portion_grams: 150, is_recipe: false },
  { id: 'food-24', name_i18n: { en: 'Mediterranean Quinoa & Chickpea Bowl', es: 'Bowl Mediterráneo de Quinoa y Garbanzos', it: 'Bowl Mediterranea di Quinoa e Ceci' }, category: 'Recipes', kcal_per_100g: 145, protein_per_100g: 6.8, carbs_per_100g: 19.5, fat_per_100g: 4.6, fiber_per_100g: 4.9, default_portion_name: '1 bowl (320g)', default_portion_grams: 320, is_recipe: true, recipe_instructions: 'Combine cooked quinoa, roasted chickpeas, cherry tomatoes, cucumber, Kalamata olives, parsley, lemon juice, and 1 tbsp EVOO.' },
];

const DEFAULT_LOCAL_MEAL_PLANS = [
  {
    id: 'plan-tpl-mediterranean',
    patient_id: null,
    is_template: true,
    title: 'Plan Mediterráneo Antiinflamatorio (1750 kcal)',
    language: 'es',
    status: 'active',
    target_kcal: 1750,
    target_macros: { protein_g: 115, carbs_g: 175, fat_g: 65, fiber_g: 34 },
    general_guidelines:
      '• Prioriza 2.0–2.5 L de agua al día.\n• Utiliza Aceite de Oliva Virgen Extra (AOVE) en crudo para aliñar.\n• Mastica despacio y procura cenar al menos 2 horas antes de descansar.',
    days: [
      {
        id: 'day-1',
        label: 'Día Base / Lunes – Viernes',
        meals: [
          {
            id: 'meal-breakfast',
            slot: 'breakfast',
            time: '08:00',
            notes: 'Comienza con un vaso de agua templada.',
            items: [
              { id: 'i-1', name: 'Pan Integral de Masa Madre', category: 'Grains', grams: 70, portion_label: '2 rebanadas (70g)', kcal: 173, protein_g: 7.4, carbs_g: 30.1, fat_g: 2.4, fiber_g: 4.8, alternatives: '50g Copos de avena integral' },
              { id: 'i-2', name: 'Huevos Enteros Camperos', category: 'Proteins', grams: 110, portion_label: '2 huevos revueltos o poché (110g)', kcal: 157, protein_g: 13.9, carbs_g: 0.8, fat_g: 10.5, fiber_g: 0.0, alternatives: '100g Requesón / Queso cottage' },
              { id: 'i-3', name: 'Aguacate Hass Fresco', category: 'Fats', grams: 60, portion_label: '1/2 aguacate pequeño (60g)', kcal: 96, protein_g: 1.2, carbs_g: 5.1, fat_g: 8.8, fiber_g: 4.0, alternatives: '10g AOVE con tomate natural' },
            ],
          },
          {
            id: 'meal-midmorning',
            slot: 'mid_morning',
            time: '11:00',
            notes: 'Snack saciante rico en antioxidantes.',
            items: [
              { id: 'i-4', name: 'Yogur Griego Natural Ligero', category: 'Dairy', grams: 170, portion_label: '1 bol (170g)', kcal: 124, protein_g: 16.8, carbs_g: 6.5, fat_g: 3.2, fiber_g: 0.0, alternatives: 'Yogur vegetal de soja' },
              { id: 'i-5', name: 'Frutos Rojos (Arándanos y Fresas)', category: 'Fruits', grams: 100, portion_label: '1 taza (100g)', kcal: 45, protein_g: 0.8, carbs_g: 10.5, fat_g: 0.3, fiber_g: 3.2, alternatives: '1 Manzana mediana' },
            ],
          },
          {
            id: 'meal-lunch',
            slot: 'lunch',
            time: '14:00',
            notes: 'Plato completo equilibrado (Método del Plato).',
            items: [
              { id: 'i-6', name: 'Pechuga de Pollo (Plancha)', category: 'Proteins', grams: 160, portion_label: '1 filete mediano (160g)', kcal: 264, protein_g: 49.6, carbs_g: 0.0, fat_g: 5.8, fiber_g: 0.0, alternatives: '160g Pavo o 180g Tofu firme' },
              { id: 'i-7', name: 'Quinoa Cocida', category: 'Grains', grams: 160, portion_label: '1 taza cocida (160g)', kcal: 192, protein_g: 7.0, carbs_g: 34.1, fat_g: 3.0, fiber_g: 4.5, alternatives: '160g Arroz integral o 180g Lentejas' },
              { id: 'i-8', name: 'Espinacas y Brotes Verdes', category: 'Produce', grams: 150, portion_label: 'Ensalada variada (150g)', kcal: 35, protein_g: 4.4, carbs_g: 5.4, fat_g: 0.6, fiber_g: 3.3, alternatives: 'Verduras asadas' },
              { id: 'i-9', name: 'Aceite de Oliva Virgen Extra (AOVE)', category: 'Fats', grams: 10, portion_label: '1 cucharada sopera (10g)', kcal: 88, protein_g: 0.0, carbs_g: 0.0, fat_g: 10.0, fiber_g: 0.0, alternatives: '' },
            ],
          },
          {
            id: 'meal-snack',
            slot: 'snack',
            time: '17:30',
            notes: 'Merienda energética.',
            items: [
              { id: 'i-10', name: 'Manzana / Pera con Piel', category: 'Fruits', grams: 150, portion_label: '1 pieza mediana (150g)', kcal: 78, protein_g: 0.5, carbs_g: 20.7, fat_g: 0.3, fiber_g: 3.6, alternatives: '' },
              { id: 'i-11', name: 'Nueces y Almendras Naturales', category: 'Fats', grams: 25, portion_label: '1 puñado (25g)', kcal: 152, protein_g: 4.6, carbs_g: 4.2, fat_g: 13.6, fiber_g: 2.5, alternatives: '' },
            ],
          },
          {
            id: 'meal-dinner',
            slot: 'dinner',
            time: '20:30',
            notes: 'Cena digestiva rica en Omega-3.',
            items: [
              { id: 'i-12', name: 'Salmón Fresco', category: 'Proteins', grams: 140, portion_label: '1 lomo al horno (140g)', kcal: 291, protein_g: 28.6, carbs_g: 0.0, fat_g: 18.8, fiber_g: 0.0, alternatives: '180g Merluza al horno con 10g AOVE' },
              { id: 'i-13', name: 'Brócoli y Calabacín al Vapor', category: 'Produce', grams: 220, portion_label: '1 plato generoso (220g)', kcal: 62, protein_g: 5.3, carbs_g: 11.4, fat_g: 0.7, fiber_g: 5.3, alternatives: 'Crema de verduras casera' },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'plan-patient-demo-1',
    patient_id: 'patient-demo-1',
    is_template: false,
    title: 'Piano Mediterraneo Controllo Glicemico – Elena Rossi',
    language: 'it',
    status: 'active',
    target_kcal: 1700,
    target_macros: { protein_g: 115, carbs_g: 165, fat_g: 62, fiber_g: 32 },
    general_guidelines:
      '• Bere almeno 2.2L di acqua naturale durante la giornata.\n• Iniziare il pranzo e la cena con una porzione di verdura cruda o cotta per ridurre il picco glicemico.\n• Utilizzare Olio EVO a crudo.',
    days: [
      {
        id: 'day-1',
        label: 'Giorno Tipo (Lunedì – Venerdì)',
        meals: [
          {
            id: 'meal-breakfast',
            slot: 'breakfast',
            time: '08:00',
            notes: 'Colazione salata bilanciata.',
            items: [
              { id: 'el-1', name: 'Pane Integrale a Lievitazione Naturale', category: 'Grains', grams: 70, portion_label: '2 fette (70g)', kcal: 173, protein_g: 7.4, carbs_g: 30.1, fat_g: 2.4, fiber_g: 4.8, alternatives: "50g Fiocchi d'avena" },
              { id: 'el-2', name: 'Uova Intere', category: 'Proteins', grams: 110, portion_label: '2 uova strapazzate (110g)', kcal: 157, protein_g: 13.9, carbs_g: 0.8, fat_g: 10.5, fiber_g: 0.0, alternatives: '100g Ricotta fresca' },
              { id: 'el-3', name: 'Avocado Maturo', category: 'Fats', grams: 60, portion_label: '1/2 avocado (60g)', kcal: 96, protein_g: 1.2, carbs_g: 5.1, fat_g: 8.8, fiber_g: 4.0, alternatives: '10g Olio EVO' },
            ],
          },
          {
            id: 'meal-lunch',
            slot: 'lunch',
            time: '13:30',
            notes: 'Iniziare con verdura a foglia verde.',
            items: [
              { id: 'el-4', name: 'Petto di Pollo (Alla Piastra)', category: 'Proteins', grams: 150, portion_label: '150g', kcal: 248, protein_g: 46.5, carbs_g: 0.0, fat_g: 5.4, fiber_g: 0.0, alternatives: '150g Fesa di tacchino o 160g Ceci cotti' },
              { id: 'el-5', name: 'Quinoa Cotta', category: 'Grains', grams: 150, portion_label: '150g cotta', kcal: 180, protein_g: 6.6, carbs_g: 32.0, fat_g: 2.9, fiber_g: 4.2, alternatives: '150g Riso integrale' },
              { id: 'el-6', name: 'Spinaci e Misticanza', category: 'Produce', grams: 150, portion_label: '150g', kcal: 35, protein_g: 4.4, carbs_g: 5.4, fat_g: 0.6, fiber_g: 3.3, alternatives: '' },
              { id: 'el-7', name: "Olio Extravergine d'Oliva (EVO)", category: 'Fats', grams: 10, portion_label: '1 cucchiaio (10g)', kcal: 88, protein_g: 0.0, carbs_g: 0.0, fat_g: 10.0, fiber_g: 0.0, alternatives: '' },
            ],
          },
          {
            id: 'meal-snack',
            slot: 'snack',
            time: '17:00',
            notes: 'Spuntino pomeridiano anti-fame.',
            items: [
              { id: 'el-8', name: 'Yogurt Greco Bianco 2%', category: 'Dairy', grams: 170, portion_label: '1 vasetto (170g)', kcal: 124, protein_g: 16.8, carbs_g: 6.5, fat_g: 3.2, fiber_g: 0.0, alternatives: '' },
              { id: 'el-9', name: 'Frutti di Bosco Freschi', category: 'Fruits', grams: 120, portion_label: '120g', kcal: 54, protein_g: 1.0, carbs_g: 12.6, fat_g: 0.4, fiber_g: 3.8, alternatives: '1 Mela con buccia' },
              { id: 'el-10', name: 'Noci e Mandorle al Naturale', category: 'Fats', grams: 20, portion_label: '20g', kcal: 121, protein_g: 3.6, carbs_g: 3.3, fat_g: 10.9, fiber_g: 2.0, alternatives: '' },
            ],
          },
          {
            id: 'meal-dinner',
            slot: 'dinner',
            time: '20:15',
            notes: 'Cena leggera con pesce azzurro o bianco.',
            items: [
              { id: 'el-11', name: 'Salmone Fresco', category: 'Proteins', grams: 140, portion_label: '140g al forno', kcal: 291, protein_g: 28.6, carbs_g: 0.0, fat_g: 18.8, fiber_g: 0.0, alternatives: '180g Merluzzo al forno' },
              { id: 'el-12', name: 'Broccoli e Zucchine al Vapore', category: 'Produce', grams: 200, portion_label: '200g', kcal: 56, protein_g: 4.8, carbs_g: 10.4, fat_g: 0.6, fiber_g: 4.8, alternatives: '' },
            ],
          },
        ],
      },
    ],
  },
];

const readLocalJson = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};

const writeLocalJson = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore storage quota errors
  }
};

// ── Session helpers ─────────────────────────────────────────────────────────

const encodeBase64Url = (obj) => {
  const str = JSON.stringify(obj);
  return btoa(unescape(encodeURIComponent(str)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

const createLocalSessionToken = (email) => {
  const nowSec = Math.floor(Date.now() / 1000);
  const expSec = nowSec + 8 * 3600; // 8 hours
  const header = encodeBase64Url({ alg: 'HS256', typ: 'JWT' });
  const payload = encodeBase64Url({
    sub: email,
    scope: 'admin',
    local: true,
    iat: nowSec,
    exp: expSec,
  });
  return `${header}.${payload}.local-dummy-signature`;
};

const decodeJwtPayload = (token) => {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getAdminProfile = () => {
  try {
    return JSON.parse(localStorage.getItem(PROFILE_KEY) || 'null');
  } catch {
    return null;
  }
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(PROFILE_KEY);
};

export const isLocalSession = () => {
  const token = getToken();
  if (!token) return false;
  const payload = decodeJwtPayload(token);
  return Boolean(payload?.local);
};

/** True when a non-expired admin token is stored (the server re-validates every request). */
export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  const payload = decodeJwtPayload(token);
  if (!payload?.exp || payload.exp * 1000 <= Date.now()) {
    clearSession();
    return false;
  }
  return true;
};

// ── HTTP ────────────────────────────────────────────────────────────────────

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

const request = async (path, { method = 'GET', body, auth = true, isFormData = false } = {}) => {
  const headers = {};
  if (!isFormData) headers['Content-Type'] = 'application/json';
  if (auth) headers.Authorization = `Bearer ${getToken() || ''}`;

  let res;
  try {
    res = await fetch(`${API_URL}${path}`, {
      method,
      headers,
      body: isFormData ? body : body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new ApiError('Cannot reach the server. Please try again in a moment.', 0);
  }

  if (auth && res.status === 401 && !isLocalSession()) {
    clearSession();
    window.location.href = '/admin';
    throw new ApiError('Session expired', 401);
  }

  const data = await res.json().catch(() => null);
  if (!res.ok) throw new ApiError(data?.detail || `Request failed (${res.status})`, res.status);
  return data;
};

const withLocalFallback = async (apiCall, localFallbackFn) => {
  try {
    return await apiCall();
  } catch (err) {
    if (isLocalSession() || err.status === 0 || err.status === 401 || err.status === 404) {
      return localFallbackFn();
    }
    throw err;
  }
};

// ── API ─────────────────────────────────────────────────────────────────────

export const adminApi = {
  /** Sign in with username/email and password (supports backend + built-in dummy user). */
  async loginWithPassword(username, password) {
    const cleanEmail = (username || '').trim().toLowerCase();
    const isDummyMatch =
      cleanEmail === DUMMY_ADMIN_EMAIL && password === DUMMY_ADMIN_PASS;

    try {
      const data = await request('/api/admin/auth/login', {
        method: 'POST',
        body: { username: cleanEmail, password },
        auth: false,
      });
      localStorage.setItem(TOKEN_KEY, data.access_token);
      localStorage.setItem(PROFILE_KEY, JSON.stringify(data.admin));
      return data;
    } catch (err) {
      if (isDummyMatch && (err.status === 0 || err.status === 404 || err.status >= 500)) {
        const admin = {
          id: '00000000-0000-0000-0000-000000000001',
          email: DUMMY_ADMIN_EMAIL,
          name: 'Paola Michelle',
          picture_url: null,
          last_login_at: new Date().toISOString(),
        };
        const token = createLocalSessionToken(DUMMY_ADMIN_EMAIL);
        localStorage.setItem(TOKEN_KEY, token);
        localStorage.setItem(PROFILE_KEY, JSON.stringify(admin));
        return {
          access_token: token,
          token_type: 'bearer',
          expires_in: 8 * 3600,
          admin,
        };
      }
      if (!isDummyMatch && (err.status === 0 || err.status === 404)) {
        throw new ApiError('Invalid username or password.', 401);
      }
      throw err;
    }
  },

  /** Exchange a Google ID token (from the GIS button) for an admin session. */
  async loginWithGoogle(credential) {
    const data = await request('/api/admin/auth/google', {
      method: 'POST',
      body: { credential },
      auth: false,
    });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    localStorage.setItem(PROFILE_KEY, JSON.stringify(data.admin));
    return data;
  },

  logout() {
    clearSession();
    window.google?.accounts?.id?.disableAutoSelect();
  },

  getMe: () =>
    withLocalFallback(
      () => request('/api/admin/me'),
      () =>
        getAdminProfile() || {
          id: '00000000-0000-0000-0000-000000000001',
          email: DUMMY_ADMIN_EMAIL,
          name: 'Paola Michelle',
        }
    ),

  getStats: () =>
    withLocalFallback(
      () => request('/api/admin/stats'),
      () => {
        const bookings = readLocalJson(LS_BOOKINGS_KEY, []);
        return {
          total_bookings: bookings.length,
          confirmed_bookings: bookings.filter((b) => b.status === 'confirmed').length,
          cancelled_bookings: bookings.filter((b) => b.status === 'cancelled').length,
          pending_bookings: bookings.filter((b) => b.status === 'pending').length,
          total_revenue_cents: 0,
          upcoming_today: 0,
        };
      }
    ),

  getUpcoming: () =>
    withLocalFallback(
      () => request('/api/admin/bookings/upcoming'),
      () => readLocalJson(LS_BOOKINGS_KEY, []).filter((b) => b.status === 'confirmed')
    ),

  getAllBookings(status = '') {
    const params = status ? `?status=${encodeURIComponent(status)}` : '';
    return withLocalFallback(
      () => request(`/api/admin/bookings${params}`),
      () => {
        const all = readLocalJson(LS_BOOKINGS_KEY, []);
        return status ? all.filter((b) => b.status === status) : all;
      }
    );
  },

  updateNotes: (bookingId, adminNotes) =>
    withLocalFallback(
      () =>
        request(`/api/admin/bookings/${bookingId}/notes`, {
          method: 'PATCH',
          body: { admin_notes: adminNotes },
        }),
      () => {
        const all = readLocalJson(LS_BOOKINGS_KEY, []).map((b) =>
          b.id === bookingId ? { ...b, admin_notes: adminNotes } : b
        );
        writeLocalJson(LS_BOOKINGS_KEY, all);
        return { message: 'Notes updated' };
      }
    ),

  updateStatus: (bookingId, status) =>
    withLocalFallback(
      () =>
        request(`/api/admin/bookings/${bookingId}/status`, {
          method: 'PATCH',
          body: { status },
        }),
      () => {
        const all = readLocalJson(LS_BOOKINGS_KEY, []).map((b) =>
          b.id === bookingId ? { ...b, status } : b
        );
        writeLocalJson(LS_BOOKINGS_KEY, all);
        return { message: `Status updated to ${status}` };
      }
    ),

  // ── Products & Ebooks (prices + PDF upload) ──
  getProducts: (kind = '') =>
    withLocalFallback(
      () => request(`/api/admin/products${kind ? `?kind=${encodeURIComponent(kind)}` : ''}`),
      () => {
        const list = readLocalJson(LS_PRODUCTS_KEY, DEFAULT_LOCAL_PRODUCTS);
        return kind ? list.filter((p) => p.kind === kind) : list;
      }
    ),

  createProduct: (payload) =>
    withLocalFallback(
      () => request('/api/admin/products', { method: 'POST', body: payload }),
      () => {
        const list = readLocalJson(LS_PRODUCTS_KEY, DEFAULT_LOCAL_PRODUCTS);
        const created = {
          ...payload,
          id: `local-${Date.now()}`,
          has_pdf: false,
          created_at: new Date().toISOString(),
        };
        writeLocalJson(LS_PRODUCTS_KEY, [...list, created]);
        return created;
      }
    ),

  updateProduct: (productId, payload) =>
    withLocalFallback(
      () => request(`/api/admin/products/${productId}`, { method: 'PATCH', body: payload }),
      () => {
        const list = readLocalJson(LS_PRODUCTS_KEY, DEFAULT_LOCAL_PRODUCTS);
        let updatedItem = null;
        const next = list.map((p) => {
          if (p.id === productId) {
            updatedItem = { ...p, ...payload };
            return updatedItem;
          }
          return p;
        });
        writeLocalJson(LS_PRODUCTS_KEY, next);
        return updatedItem || { id: productId, ...payload };
      }
    ),

  deleteProduct: (productId) =>
    withLocalFallback(
      () => request(`/api/admin/products/${productId}`, { method: 'DELETE' }),
      () => {
        const list = readLocalJson(LS_PRODUCTS_KEY, DEFAULT_LOCAL_PRODUCTS).filter(
          (p) => p.id !== productId
        );
        writeLocalJson(LS_PRODUCTS_KEY, list);
        return { message: 'Product deleted' };
      }
    ),

  uploadProductPdf(productId, file) {
    const form = new FormData();
    form.append('file', file);
    return withLocalFallback(
      () =>
        request(`/api/admin/products/${productId}/pdf`, {
          method: 'POST',
          body: form,
          isFormData: true,
        }),
      () => {
        const list = readLocalJson(LS_PRODUCTS_KEY, DEFAULT_LOCAL_PRODUCTS);
        let updatedItem = null;
        const next = list.map((p) => {
          if (p.id === productId) {
            updatedItem = {
              ...p,
              has_pdf: true,
              pdf_filename: file.name,
              pdf_size_bytes: file.size,
            };
            return updatedItem;
          }
          return p;
        });
        writeLocalJson(LS_PRODUCTS_KEY, next);
        return updatedItem;
      }
    );
  },

  // ── Availability & Calendar ──
  getAvailability: () =>
    withLocalFallback(
      () => request('/api/admin/availability'),
      () => readLocalJson(LS_AVAILABILITY_KEY, DEFAULT_LOCAL_AVAILABILITY)
    ),

  updateAvailabilitySettings: (payload) =>
    withLocalFallback(
      () => request('/api/admin/availability/settings', { method: 'PATCH', body: payload }),
      () => {
        const bundle = readLocalJson(LS_AVAILABILITY_KEY, DEFAULT_LOCAL_AVAILABILITY);
        const updatedSettings = { ...bundle.settings, ...payload };
        writeLocalJson(LS_AVAILABILITY_KEY, { ...bundle, settings: updatedSettings });
        return updatedSettings;
      }
    ),

  replaceAvailabilityRules: (rules) =>
    withLocalFallback(
      () => request('/api/admin/availability/rules', { method: 'PUT', body: rules }),
      () => {
        const bundle = readLocalJson(LS_AVAILABILITY_KEY, DEFAULT_LOCAL_AVAILABILITY);
        const savedRules = rules.map((r, idx) => ({ ...r, id: r.id || `rule-${idx}-${Date.now()}` }));
        writeLocalJson(LS_AVAILABILITY_KEY, { ...bundle, rules: savedRules });
        return savedRules;
      }
    ),

  createAvailabilityException: (payload) =>
    withLocalFallback(
      () => request('/api/admin/availability/exceptions', { method: 'POST', body: payload }),
      () => {
        const bundle = readLocalJson(LS_AVAILABILITY_KEY, DEFAULT_LOCAL_AVAILABILITY);
        const created = { ...payload, id: `ex-${Date.now()}` };
        const exceptions = [...(bundle.exceptions || []), created];
        writeLocalJson(LS_AVAILABILITY_KEY, { ...bundle, exceptions });
        return created;
      }
    ),

  deleteAvailabilityException: (exceptionId) =>
    withLocalFallback(
      () => request(`/api/admin/availability/exceptions/${exceptionId}`, { method: 'DELETE' }),
      () => {
        const bundle = readLocalJson(LS_AVAILABILITY_KEY, DEFAULT_LOCAL_AVAILABILITY);
        const exceptions = (bundle.exceptions || []).filter((e) => e.id !== exceptionId);
        writeLocalJson(LS_AVAILABILITY_KEY, { ...bundle, exceptions });
        return { message: 'Exception removed' };
      }
    ),

  // ── Contact messages ──
  getContacts: () =>
    withLocalFallback(
      () => request('/api/admin/contacts'),
      () => readLocalJson(LS_CONTACTS_KEY, [])
    ),

  // ── Nutrium-style Practice CRM: Patients ──
  getPatients: (search = '', statusFilter = 'all') => {
    const qs = new URLSearchParams();
    if (search) qs.set('search', search);
    if (statusFilter && statusFilter !== 'all') qs.set('status_filter', statusFilter);
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return withLocalFallback(
      () => request(`/api/admin/patients${suffix}`),
      () => {
        let list = readLocalJson(LS_PATIENTS_KEY, DEFAULT_LOCAL_PATIENTS);
        if (statusFilter && statusFilter !== 'all') {
          list = list.filter((p) => p.status === statusFilter);
        }
        if (search && search.trim()) {
          const q = search.trim().toLowerCase();
          list = list.filter(
            (p) =>
              (p.full_name || '').toLowerCase().includes(q) ||
              (p.email || '').toLowerCase().includes(q) ||
              (p.phone || '').toLowerCase().includes(q)
          );
        }
        return list;
      }
    );
  },

  createPatient: (payload) =>
    withLocalFallback(
      () => request('/api/admin/patients', { method: 'POST', body: payload }),
      () => {
        const list = readLocalJson(LS_PATIENTS_KEY, DEFAULT_LOCAL_PATIENTS);
        const created = {
          status: 'active',
          preferred_language: 'es',
          tags: [],
          clinical_profile: {},
          target_kcal: 1800,
          target_macros: { protein_g: 110, carbs_g: 180, fat_g: 65, fiber_g: 30, water_liters: 2.2 },
          ...payload,
          id: `patient-${Date.now()}`,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        };
        writeLocalJson(LS_PATIENTS_KEY, [created, ...list]);
        return created;
      }
    ),

  createOrGetPatientFromBooking: (booking) =>
    withLocalFallback(
      () => request(`/api/admin/patients/from-booking/${booking.id}`, { method: 'POST' }),
      () => {
        const list = readLocalJson(LS_PATIENTS_KEY, DEFAULT_LOCAL_PATIENTS);
        const existing = list.find(
          (p) => p.email && booking.email && p.email.toLowerCase() === booking.email.toLowerCase()
        );
        if (existing) return existing;
        const created = {
          id: `patient-${Date.now()}`,
          full_name: booking.name || 'Patient',
          email: booking.email || '',
          phone: booking.phone || '',
          sex: 'female',
          preferred_language: 'es',
          status: 'active',
          tags: ['Consultation'],
          clinical_profile: {
            primary_goal: booking.concerns || 'Initial nutrition consultation',
            clinical_summary: booking.admin_notes || '',
          },
          target_kcal: 1800,
          target_macros: { protein_g: 110, carbs_g: 180, fat_g: 65, fiber_g: 30, water_liters: 2.2 },
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        };
        writeLocalJson(LS_PATIENTS_KEY, [created, ...list]);
        return created;
      }
    ),

  updatePatient: (patientId, payload) =>
    withLocalFallback(
      () => request(`/api/admin/patients/${patientId}`, { method: 'PATCH', body: payload }),
      () => {
        const list = readLocalJson(LS_PATIENTS_KEY, DEFAULT_LOCAL_PATIENTS);
        let updated = null;
        const next = list.map((p) => {
          if (p.id === patientId) {
            updated = { ...p, ...payload, updated_at: new Date().toISOString() };
            return updated;
          }
          return p;
        });
        writeLocalJson(LS_PATIENTS_KEY, next);
        return updated || { id: patientId, ...payload };
      }
    ),

  deletePatient: (patientId) =>
    withLocalFallback(
      () => request(`/api/admin/patients/${patientId}`, { method: 'DELETE' }),
      () => {
        const list = readLocalJson(LS_PATIENTS_KEY, DEFAULT_LOCAL_PATIENTS).filter(
          (p) => p.id !== patientId
        );
        writeLocalJson(LS_PATIENTS_KEY, list);
        return { message: 'Patient deleted' };
      }
    ),

  // ── Consultation SOAP Notes ──
  getPatientNotes: (patientId) =>
    withLocalFallback(
      () => request(`/api/admin/patients/${patientId}/notes`),
      () =>
        readLocalJson(LS_NOTES_KEY, DEFAULT_LOCAL_NOTES)
          .filter((n) => n.patient_id === patientId)
          .sort((a, b) => (b.session_date || '').localeCompare(a.session_date || ''))
    ),

  createPatientNote: (patientId, payload) =>
    withLocalFallback(
      () => request(`/api/admin/patients/${patientId}/notes`, { method: 'POST', body: payload }),
      () => {
        const list = readLocalJson(LS_NOTES_KEY, DEFAULT_LOCAL_NOTES);
        const created = {
          ...payload,
          id: `note-${Date.now()}`,
          patient_id: patientId,
          created_at: new Date().toISOString(),
        };
        writeLocalJson(LS_NOTES_KEY, [created, ...list]);
        return created;
      }
    ),

  updatePatientNote: (patientId, noteId, payload) =>
    withLocalFallback(
      () =>
        request(`/api/admin/patients/${patientId}/notes/${noteId}`, {
          method: 'PATCH',
          body: payload,
        }),
      () => {
        const list = readLocalJson(LS_NOTES_KEY, DEFAULT_LOCAL_NOTES);
        let updated = null;
        const next = list.map((n) => {
          if (n.id === noteId) {
            updated = { ...n, ...payload };
            return updated;
          }
          return n;
        });
        writeLocalJson(LS_NOTES_KEY, next);
        return updated;
      }
    ),

  deletePatientNote: (patientId, noteId) =>
    withLocalFallback(
      () => request(`/api/admin/patients/${patientId}/notes/${noteId}`, { method: 'DELETE' }),
      () => {
        const list = readLocalJson(LS_NOTES_KEY, DEFAULT_LOCAL_NOTES).filter(
          (n) => n.id !== noteId
        );
        writeLocalJson(LS_NOTES_KEY, list);
        return { message: 'Note deleted' };
      }
    ),

  // ── Anthropometric & Biomarker Measurements ──
  getPatientMeasurements: (patientId) =>
    withLocalFallback(
      () => request(`/api/admin/patients/${patientId}/measurements`),
      () =>
        readLocalJson(LS_MEASUREMENTS_KEY, DEFAULT_LOCAL_MEASUREMENTS)
          .filter((m) => m.patient_id === patientId)
          .sort((a, b) => (a.measured_at || '').localeCompare(b.measured_at || ''))
    ),

  createPatientMeasurement: (patientId, payload) =>
    withLocalFallback(
      () =>
        request(`/api/admin/patients/${patientId}/measurements`, {
          method: 'POST',
          body: payload,
        }),
      () => {
        const list = readLocalJson(LS_MEASUREMENTS_KEY, DEFAULT_LOCAL_MEASUREMENTS);
        let bmi = payload.bmi;
        if (!bmi && payload.weight_kg && payload.height_cm) {
          const hm = payload.height_cm / 100;
          if (hm > 0) bmi = Number((payload.weight_kg / (hm * hm)).toFixed(1));
        }
        const created = {
          ...payload,
          bmi,
          id: `meas-${Date.now()}`,
          patient_id: patientId,
          created_at: new Date().toISOString(),
        };
        writeLocalJson(LS_MEASUREMENTS_KEY, [...list, created]);
        return created;
      }
    ),

  deletePatientMeasurement: (patientId, measurementId) =>
    withLocalFallback(
      () =>
        request(`/api/admin/patients/${patientId}/measurements/${measurementId}`, {
          method: 'DELETE',
        }),
      () => {
        const list = readLocalJson(LS_MEASUREMENTS_KEY, DEFAULT_LOCAL_MEASUREMENTS).filter(
          (m) => m.id !== measurementId
        );
        writeLocalJson(LS_MEASUREMENTS_KEY, list);
        return { message: 'Measurement deleted' };
      }
    ),

  // ── Meal Plans & Reusable Templates ──
  getMealPlans: ({ patientId = null, isTemplate = null } = {}) => {
    const qs = new URLSearchParams();
    if (patientId) qs.set('patient_id', patientId);
    if (isTemplate !== null) qs.set('is_template', String(isTemplate));
    const suffix = qs.toString() ? `?${qs.toString()}` : '';
    return withLocalFallback(
      () => request(`/api/admin/meal-plans${suffix}`),
      () => {
        let list = readLocalJson(LS_MEAL_PLANS_KEY, DEFAULT_LOCAL_MEAL_PLANS);
        if (patientId) list = list.filter((m) => m.patient_id === patientId);
        if (isTemplate !== null) list = list.filter((m) => Boolean(m.is_template) === Boolean(isTemplate));
        return list;
      }
    );
  },

  createMealPlan: (payload) =>
    withLocalFallback(
      () => request('/api/admin/meal-plans', { method: 'POST', body: payload }),
      () => {
        const list = readLocalJson(LS_MEAL_PLANS_KEY, DEFAULT_LOCAL_MEAL_PLANS);
        const created = {
          ...payload,
          id: `plan-${Date.now()}`,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        };
        writeLocalJson(LS_MEAL_PLANS_KEY, [created, ...list]);
        return created;
      }
    ),

  updateMealPlan: (planId, payload) =>
    withLocalFallback(
      () => request(`/api/admin/meal-plans/${planId}`, { method: 'PATCH', body: payload }),
      () => {
        const list = readLocalJson(LS_MEAL_PLANS_KEY, DEFAULT_LOCAL_MEAL_PLANS);
        let updated = null;
        const next = list.map((p) => {
          if (p.id === planId) {
            updated = { ...p, ...payload, updated_at: new Date().toISOString() };
            return updated;
          }
          return p;
        });
        writeLocalJson(LS_MEAL_PLANS_KEY, next);
        return updated;
      }
    ),

  deleteMealPlan: (planId) =>
    withLocalFallback(
      () => request(`/api/admin/meal-plans/${planId}`, { method: 'DELETE' }),
      () => {
        const list = readLocalJson(LS_MEAL_PLANS_KEY, DEFAULT_LOCAL_MEAL_PLANS).filter(
          (p) => p.id !== planId
        );
        writeLocalJson(LS_MEAL_PLANS_KEY, list);
        return { message: 'Meal plan deleted' };
      }
    ),

  // ── Food & Recipe Database ──
  getFoods: (category = '') =>
    withLocalFallback(
      () => request(`/api/admin/foods${category ? `?category=${encodeURIComponent(category)}` : ''}`),
      () => {
        const list = readLocalJson(LS_FOODS_KEY, DEFAULT_LOCAL_FOODS);
        return category && category !== 'all' ? list.filter((f) => f.category === category) : list;
      }
    ),

  createFood: (payload) =>
    withLocalFallback(
      () => request('/api/admin/foods', { method: 'POST', body: payload }),
      () => {
        const list = readLocalJson(LS_FOODS_KEY, DEFAULT_LOCAL_FOODS);
        const created = {
          ...payload,
          id: `food-${Date.now()}`,
          created_at: new Date().toISOString(),
        };
        writeLocalJson(LS_FOODS_KEY, [...list, created]);
        return created;
      }
    ),

  updateFood: (foodId, payload) =>
    withLocalFallback(
      () => request(`/api/admin/foods/${foodId}`, { method: 'PATCH', body: payload }),
      () => {
        const list = readLocalJson(LS_FOODS_KEY, DEFAULT_LOCAL_FOODS);
        let updated = null;
        const next = list.map((f) => {
          if (f.id === foodId) {
            updated = { ...f, ...payload };
            return updated;
          }
          return f;
        });
        writeLocalJson(LS_FOODS_KEY, next);
        return updated;
      }
    ),

  deleteFood: (foodId) =>
    withLocalFallback(
      () => request(`/api/admin/foods/${foodId}`, { method: 'DELETE' }),
      () => {
        const list = readLocalJson(LS_FOODS_KEY, DEFAULT_LOCAL_FOODS).filter((f) => f.id !== foodId);
        writeLocalJson(LS_FOODS_KEY, list);
        return { message: 'Food deleted' };
      }
    ),
};
